import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "profile-left"
}
const _hoisted_2 = { class: "ps-wrap" }
const _hoisted_3 = { class: "ps-nav" }
const _hoisted_4 = { class: "ps-ava" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = {
  key: 1,
  class: "ps-ava-ph"
}
const _hoisted_7 = { class: "ps-user-info" }
const _hoisted_8 = { class: "ps-user-name" }
const _hoisted_9 = { class: "ps-user-handle" }
const _hoisted_10 = { class: "ps-tabs" }
const _hoisted_11 = { class: "ps-content" }
const _hoisted_12 = { class: "crop-modal" }
const _hoisted_13 = { class: "crop-title" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "crop-mask" }
const _hoisted_16 = { class: "crop-zoom-row" }
const _hoisted_17 = { class: "crop-zoom-label" }
const _hoisted_18 = { class: "crop-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PhotoCarousel = _resolveComponent("PhotoCarousel")!
  const _component_ProfileInfoTab = _resolveComponent("ProfileInfoTab")!
  const _component_ProfileSegurancaTab = _resolveComponent("ProfileSegurancaTab")!
  const _component_ProfileEmailTab = _resolveComponent("ProfileEmailTab")!
  const _component_ProfileAparenciaTab = _resolveComponent("ProfileAparenciaTab")!
  const _component_ProfileOfflineTab = _resolveComponent("ProfileOfflineTab")!
  const _component_ProfileNotificacoesTab = _resolveComponent("ProfileNotificacoesTab")!
  const _component_ProfileFusoTab = _resolveComponent("ProfileFusoTab")!
  const _component_ProfileVersoesTab = _resolveComponent("ProfileVersoesTab")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["profile-shell", { 'profile-shell--panel': _ctx.inPanel }])
  }, [
    (!_ctx.inPanel)
      ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
          _createVNode(_component_PhotoCarousel, { images: _ctx.carouselImages }, null, 8, ["images"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("section", {
      class: _normalizeClass(["profile-right", { 'profile-right--panel': _ctx.inPanel }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("nav", _hoisted_3, [
          _createElementVNode("div", {
            class: "ps-user-card",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.triggerAvatarInput && _ctx.triggerAvatarInput(...args))),
            title: "Alterar foto"
          }, [
            _createElementVNode("div", _hoisted_4, [
              (_ctx.avatar)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.$resolveUrl(_ctx.avatar),
                    class: "ps-ava-img",
                    alt: _ctx.$t('profile.avatarAlt')
                  }, null, 8, _hoisted_5))
                : (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString((_ctx.name || 'U').charAt(0).toUpperCase()), 1)),
              _cache[18] || (_cache[18] = _createElementVNode("span", { class: "ps-ava-badge" }, [
                _createElementVNode("svg", {
                  width: "9",
                  height: "9",
                  viewBox: "0 0 12 12",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2"
                }, [
                  _createElementVNode("path", { d: "M9 2l1 1-5 5H4V7l5-5z" }),
                  _createElementVNode("path", { d: "M7.5 3.5l1 1" })
                ])
              ], -1))
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.name || '—'), 1),
              _createElementVNode("p", _hoisted_9, "@" + _toDisplayString(_ctx.username), 1)
            ])
          ]),
          _createElementVNode("input", {
            id: "avatar-file",
            class: "hidden-input",
            type: "file",
            accept: "image/*",
            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onAvatarSelected && _ctx.onAvatarSelected(...args)))
          }, null, 32),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", {
              class: _normalizeClass(["ps-tab", { 'ps-tab--active': _ctx.activeTab === 'info' }]),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goTab('editar')))
            }, [
              _cache[19] || (_cache[19] = _createElementVNode("svg", {
                width: "15",
                height: "15",
                viewBox: "0 0 16 16",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "1.4"
              }, [
                _createElementVNode("circle", {
                  cx: "8",
                  cy: "5",
                  r: "2.5"
                }),
                _createElementVNode("path", {
                  d: "M3 13c0-3.3 2.2-5 5-5s5 1.7 5 5",
                  "stroke-linecap": "round"
                })
              ], -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('profile.editProfile')), 1)
            ], 2),
            _createElementVNode("button", {
              class: _normalizeClass(["ps-tab", { 'ps-tab--active': _ctx.activeTab === 'security' }]),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goTab('seguranca')))
            }, [...(_cache[20] || (_cache[20] = [
              _createElementVNode("svg", {
                width: "15",
                height: "15",
                viewBox: "0 0 16 16",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "1.4"
              }, [
                _createElementVNode("rect", {
                  x: "3",
                  y: "7",
                  width: "10",
                  height: "7",
                  rx: "2"
                }),
                _createElementVNode("path", {
                  d: "M5 7V5a3 3 0 0 1 6 0v2",
                  "stroke-linecap": "round"
                }),
                _createElementVNode("circle", {
                  cx: "8",
                  cy: "10.5",
                  r: "1",
                  fill: "currentColor",
                  stroke: "none"
                })
              ], -1),
              _createTextVNode(" Segurança ", -1)
            ]))], 2),
            _createElementVNode("button", {
              class: _normalizeClass(["ps-tab", { 'ps-tab--active': _ctx.activeTab === 'email' }]),
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goTab('email')))
            }, [...(_cache[21] || (_cache[21] = [
              _createElementVNode("svg", {
                width: "15",
                height: "15",
                viewBox: "0 0 16 16",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "1.4"
              }, [
                _createElementVNode("rect", {
                  x: "2",
                  y: "4",
                  width: "12",
                  height: "8",
                  rx: "1.5"
                }),
                _createElementVNode("path", {
                  d: "M2 5.5l6 4 6-4",
                  "stroke-linecap": "round"
                })
              ], -1),
              _createTextVNode(" E-mail ", -1)
            ]))], 2),
            _createElementVNode("button", {
              class: _normalizeClass(["ps-tab", { 'ps-tab--active': _ctx.activeTab === 'appearance' }]),
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.goTab('aparencia')))
            }, [
              _cache[22] || (_cache[22] = _createElementVNode("svg", {
                width: "15",
                height: "15",
                viewBox: "0 0 16 16",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "1.4"
              }, [
                _createElementVNode("circle", {
                  cx: "8",
                  cy: "8",
                  r: "3.5"
                }),
                _createElementVNode("path", {
                  d: "M8 1v1M8 14v1M1 8h1M14 8h1M3.05 3.05l.7.7M12.25 12.25l.7.7M3.05 12.95l.7-.7M12.25 3.75l.7-.7",
                  "stroke-linecap": "round"
                })
              ], -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('profile.appearance')), 1)
            ], 2),
            _createElementVNode("button", {
              class: _normalizeClass(["ps-tab", { 'ps-tab--active': _ctx.activeTab === 'offline' }]),
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.goTab('offline')))
            }, [...(_cache[23] || (_cache[23] = [
              _createElementVNode("svg", {
                width: "15",
                height: "15",
                viewBox: "0 0 16 16",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "1.4"
              }, [
                _createElementVNode("path", {
                  d: "M1 1l14 14M11.2 4.8A5 5 0 0 1 13 8M2.5 5.5A7 7 0 0 0 3.5 12M6 3.2A7 7 0 0 1 13 8m-6.5 1A2.5 2.5 0 0 1 10.5 8M5.5 12l.5.5a2.5 2.5 0 0 0 3.5 0L10 12",
                  "stroke-linecap": "round"
                })
              ], -1),
              _createTextVNode(" Offline ", -1)
            ]))], 2),
            _createElementVNode("button", {
              class: _normalizeClass(["ps-tab", { 'ps-tab--active': _ctx.activeTab === 'notifications' }]),
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.goTab('notificacoes')))
            }, [...(_cache[24] || (_cache[24] = [
              _createElementVNode("svg", {
                width: "15",
                height: "15",
                viewBox: "0 0 16 16",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "1.4"
              }, [
                _createElementVNode("path", {
                  d: "M8 1a5 5 0 0 1 5 5v3l1.5 2H1.5L3 9V6a5 5 0 0 1 5-5z",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }),
                _createElementVNode("path", {
                  d: "M6.5 13.5a1.5 1.5 0 0 0 3 0",
                  "stroke-linecap": "round"
                })
              ], -1),
              _createTextVNode(" Notificações ", -1)
            ]))], 2),
            _createElementVNode("button", {
              class: _normalizeClass(["ps-tab", { 'ps-tab--active': _ctx.activeTab === 'timezone' }]),
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.goTab('fuso')))
            }, [...(_cache[25] || (_cache[25] = [
              _createElementVNode("svg", {
                width: "15",
                height: "15",
                viewBox: "0 0 16 16",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "1.4"
              }, [
                _createElementVNode("circle", {
                  cx: "8",
                  cy: "8",
                  r: "6.5"
                }),
                _createElementVNode("path", {
                  d: "M8 4.5V8l2.5 1.5",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                })
              ], -1),
              _createTextVNode(" Fuso Horário ", -1)
            ]))], 2),
            _createElementVNode("button", {
              class: _normalizeClass(["ps-tab", { 'ps-tab--active': _ctx.activeTab === 'versions' }]),
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.goTab('versoes')))
            }, [...(_cache[26] || (_cache[26] = [
              _createElementVNode("svg", {
                width: "15",
                height: "15",
                viewBox: "0 0 16 16",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "1.4"
              }, [
                _createElementVNode("polygon", { points: "8 1 10.18 5.41 15 6.18 11.5 9.59 12.36 14.41 8 12.11 3.64 14.41 4.5 9.59 1 6.18 5.82 5.41 8 1" })
              ], -1),
              _createTextVNode(" Versões ", -1)
            ]))], 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          (_ctx.activeTab === 'info')
            ? (_openBlock(), _createBlock(_component_ProfileInfoTab, {
                key: 0,
                name: _ctx.name,
                username: _ctx.username,
                error: _ctx.error,
                "onUpdate:name": _cache[10] || (_cache[10] = ($event: any) => (_ctx.name = $event)),
                "onUpdate:username": _cache[11] || (_cache[11] = ($event: any) => (_ctx.username = $event)),
                onSave: _ctx.save,
                onCancel: _ctx.cancel
              }, null, 8, ["name", "username", "error", "onSave", "onCancel"]))
            : (_ctx.activeTab === 'security')
              ? (_openBlock(), _createBlock(_component_ProfileSegurancaTab, { key: 1 }))
              : (_ctx.activeTab === 'email')
                ? (_openBlock(), _createBlock(_component_ProfileEmailTab, { key: 2 }))
                : (_ctx.activeTab === 'appearance')
                  ? (_openBlock(), _createBlock(_component_ProfileAparenciaTab, { key: 3 }))
                  : (_ctx.activeTab === 'offline')
                    ? (_openBlock(), _createBlock(_component_ProfileOfflineTab, { key: 4 }))
                    : (_ctx.activeTab === 'notifications')
                      ? (_openBlock(), _createBlock(_component_ProfileNotificacoesTab, { key: 5 }))
                      : (_ctx.activeTab === 'timezone')
                        ? (_openBlock(), _createBlock(_component_ProfileFusoTab, { key: 6 }))
                        : (_ctx.activeTab === 'versions')
                          ? (_openBlock(), _createBlock(_component_ProfileVersoesTab, { key: 7 }))
                          : _createCommentVNode("", true)
        ])
      ])
    ], 2),
    (_ctx.cropOpen)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "crop-overlay",
          onMousedown: _cache[17] || (_cache[17] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.cancelCrop && _ctx.cancelCrop(...args)), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("h3", _hoisted_13, _toDisplayString(_ctx.$t('profile.cropTitle')), 1),
            _createElementVNode("div", {
              class: "crop-stage",
              ref: "stageRef",
              onMousedown: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.onStageDragStart && _ctx.onStageDragStart(...args))),
              onTouchstart: _cache[13] || (_cache[13] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onStageTouchStart && _ctx.onStageTouchStart(...args)), ["prevent"]))
            }, [
              _createElementVNode("img", {
                ref: "cropImgRef",
                src: _ctx.cropSrc,
                class: "crop-img",
                style: _normalizeStyle({ transform: `translate(${_ctx.imgX}px, ${_ctx.imgY}px) scale(${_ctx.imgScale})`, transformOrigin: '0 0' }),
                draggable: "false"
              }, null, 12, _hoisted_14),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", {
                  class: "crop-box",
                  style: _normalizeStyle({ width: _ctx.cropBoxSize + 'px', height: _ctx.cropBoxSize + 'px' })
                }, [...(_cache[27] || (_cache[27] = [
                  _createElementVNode("div", { class: "crop-corner tl" }, null, -1),
                  _createElementVNode("div", { class: "crop-corner tr" }, null, -1),
                  _createElementVNode("div", { class: "crop-corner bl" }, null, -1),
                  _createElementVNode("div", { class: "crop-corner br" }, null, -1)
                ]))], 4)
              ])
            ], 544),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('profile.zoom')), 1),
              _withDirectives(_createElementVNode("input", {
                type: "range",
                min: "1",
                max: "4",
                step: "0.01",
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.zoomMultiplier) = $event)),
                class: "crop-zoom-slider"
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.zoomMultiplier,
                  void 0,
                  { number: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("button", {
                class: "btn btn-ghost btn-login",
                type: "button",
                onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.cancelCrop && _ctx.cancelCrop(...args)))
              }, _toDisplayString(_ctx.$t('common.cancel')), 1),
              _createElementVNode("button", {
                class: "btn btn-primary btn-login",
                type: "button",
                onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.confirmCrop && _ctx.confirmCrop(...args)))
              }, _toDisplayString(_ctx.$t('profile.cropUse')), 1)
            ])
          ])
        ], 32))
      : _createCommentVNode("", true)
  ], 2))
}